<div class="modal-body sticky modal-container" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="sticky-header-container">
    <div class="modal-header d-flex flex-row justify-content-between">
      <div class="modal-title" tabindex="-1">{{ modalTitle }}</div>
      <app-close-button *ngIf="!hideClose" [class.disabled]="closeDisabled" (closeClicked)="handleCloseClick()" />
    </div>
  </div>
  <div class="sticky-body-container">
    <ng-content></ng-content>
  </div>
  <div class="sticky-footer-container modal-footer-flex-end">
    <ng-container *ngIf="!hideSecondary">
      <app-secondary-button
        *ngIf="secondaryButtonStyle === SecondaryButtonStyleEnum.Secondary"
        [size]="BaseButtonSizeEnum.sm"
        [colour]="BaseButtonColourEnum.Blue"
        [disabled]="isLoading || secondaryDisabled"
        [ngClass]="{ 'secondary-button': !hidePrimary }"
        (buttonClicked)="secondaryClicked.emit()">
        {{ secondaryLabel }}
      </app-secondary-button>
      <app-tertiary-button
        *ngIf="secondaryButtonStyle === SecondaryButtonStyleEnum.Tertiary"
        [size]="BaseButtonSizeEnum.sm"
        [colour]="BaseButtonColourEnum.Blue"
        [disabled]="isLoading || secondaryDisabled"
        [ngClass]="{ 'secondary-button': !hidePrimary }"
        (buttonClicked)="secondaryClicked.emit()">
        {{ secondaryLabel }}
      </app-tertiary-button>
    </ng-container>

    <app-primary-button
      [size]="BaseButtonSizeEnum.sm"
      [colour]="BaseButtonColourEnum.Blue"
      [isLoading]="isLoading"
      [disabled]="primaryDisabled"
      (buttonClicked)="primaryClicked.emit()"
      appThrottleClick
      *ngIf="!hidePrimary">
      {{ primaryLabel }}
    </app-primary-button>
  </div>
</div>
